<template>
    <v-card>
        <v-card-text class="pt-2 pb-2">
            <v-tooltip left color="primary">
                <template v-slot:activator="{ on }">
                    <div v-on="on">
                        <div class="title mb-2">{{ title }} {{ value.toLocaleString() }}{{postfix}}</div>
                        <div class="subtitle-2 font-weight-light grey--text text--lighten-2">{{subTitle}}</div>
                    </div>
                </template>
                <div v-if="count">
                    Total count: {{count.toLocaleString()}}
                </div>
            </v-tooltip>
        </v-card-text>
        <v-progress-linear :color="progressColor" :value="value"></v-progress-linear>

    </v-card>
</template>

<script>

    export default {

        props: {
            value: {
                type: Number,
                required: true,
                default: 0,
            },
            postfix: {
                type: String,
                required: false,
                default: '',
            },
            title: {
                type: String,
                required: true,
            },
            subTitle: {
                type: String,
                required: true,
            },
            count: {
                type: Number,
                required: false,
                default: null,
            },
            progressColor: {
                type: String,
                required: false,
                default: 'primary'
            }
        }
    }
</script>
